module.exports = __webpack_public_path__ + "img/Serumgray.32584642.svg";